import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

interface SiteSetting {
  id: number;
  key: string;
  value: string;
  label: string | null;
  description: string | null;
  updated_at: string;
}

export function useSiteSettings() {
  const [settings, setSettings] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetch() {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('key, value');

        if (!cancelled && data && !error) {
          const map: Record<string, string> = {};
          data.forEach((s: { key: string; value: string }) => {
            map[s.key] = s.value;
          });
          setSettings(map);
        }
      } catch {
        // silently fail, use defaults
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetch();
    return () => { cancelled = true; };
  }, []);

  return { settings, loading };
}

export type { SiteSetting };